import type { IPaletteItem } from '@repo/web-chrome/components/command-palette/palette-item-types';
import type { ICompetitor } from '@/content/compare';

export function comparePagesRegistry(content: Record<string, ICompetitor>): IPaletteItem[] {
  return Object.entries(content).map(([slug, entry]) => ({
    id: `page:compare-${slug}`,
    group: 'pages',
    title: `Cool Mate vs ${entry.name}`,
    subtitle: entry.tagline,
    href: `/compare/${slug}`,
    keywords: [entry.name, slug, 'compare', 'vs', 'alternative'],
    iconName: 'scale',
  }));
}
